
export default {
  name: 'ButtonAddToCart',

  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isAddToCart: function () {
      return Boolean(this.countFromCart > 0);
    },
    countFromCart: function () {
      const items = this.$store.state?.cart?.items || [];
      const product = items.find((t) => t?.product?.id === this.product.id);
      return product?.quantity || 0;
    },
    isAvaibleCountProduct: function () {
      return Boolean((this.product?.quantity || 0) > 0 && !this.product.isNotAvailable);
    },
    cartProductId: function () {
      const items = this.$store.state?.cart?.items || [];
      const product = items.find((t) => t?.product?.id === this.product.id);
      return product?.id || '';
    },
  },

  methods: {
    addToCart: async function () {
      const productItemCart = {
        productId: this.product.id,
        quantity: 1,
      };
      const res = await this.$store.dispatch('cart-custom/putToCart', productItemCart);
      if (!res.isSuccess) {
        this.$toast.error(res.errorMessage);
        return;
      }

      this.$toast.success('Товар добавлен в корзину');
      this.$yandexMetrika.reachGoal('add_to_cart_product_page');
      this.$yandexCommerce('add', [{
        ...this.product,
        quantity: 1,
      }]);

      await this.$store.dispatch('cart/getCart');
    },

    updateForCart: async function (newCount) {
      if (!this.isAvaibleCountProduct) {
        return;
      }
      if (this.countFromCart <= 0 && newCount > 0) {
        await this.addToCart();
        return;
      }
      const count = this.countFromCart + newCount;
      if (count <= 0) {
        await this.removeFromCart();
        return;
      }
      const response = await this.$store.dispatch('cart-custom/updateCartItem', {
        cartItemId: this.cartProductId,
        quantity: count,
      });
      if (newCount > 0) {
        this.$yandexMetrika.reachGoal('add_to_cart_listing');
      }
      if (!response?.isSuccess) {
        this.$toast.error(response?.errorMessage);
        return;
      }

      this.$yandexCommerce(newCount > 0 ? 'add' : 'remove', [{
        ...this.product,
        quantity: 1,
      }]);
      await this.$store.dispatch('cart/getCart');
    },
    removeFromCart: async function () {
      this.$yandexCommerce('remove', [{
        ...this.product,
        quantity: 1,
      }]);
      await this.$store.dispatch('cart/removeCartItem', this.cartProductId);
      await this.$store.dispatch('cart/getCart');
    },
  },
};
